// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../static/images/a1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../static/images/a2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../static/images/a3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../static/images/cloud-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cloudmodel {
  padding-bottom: 50px;
}
.cloudmodel .ant-anchor {
  display: flex;
  width: 1200px;
  margin: 0px auto;
}
.cloudmodel .ant-anchor-link {
  flex: 1;
  border: 1px solid #ddd;
  border-left: 0px;
  height: 200px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  padding-inline: 0px !important;
}
.cloudmodel .ant-anchor-link a {
  text-align: center;
  white-space: pre-wrap !important;
  padding: 0px 15px;
}
.cloudmodel .ant-anchor-link:nth-of-type(1) {
  border-left: 1px solid #ddd;
}
.cloudmodel .ant-anchor-wrapper:before {
  border-bottom: 0px !important;
}
.cloudmodel .ant-anchor-link a::before {
  content: '';
  display: block;
  height: 140px;
}
.cloudmodel .text {
  line-height: 30px;
  display: block;
}
.cloudmodel .ant-anchor-link:nth-of-type(1) a::before,
.cloudmodel .ant-anchor-link:nth-of-type(4) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center 40px;
}
.cloudmodel .ant-anchor-link:nth-of-type(2) a::before,
.cloudmodel .ant-anchor-link:nth-of-type(5) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center 40px;
}
.cloudmodel .ant-anchor-link:nth-of-type(3) a::before,
.cloudmodel .ant-anchor-link:nth-of-type(6) a::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center 40px;
}
.cloudmodel .ant-affix .ant-anchor-link {
  flex: 1;
  border: 1px solid #ddd;
  border-left: 0px;
  height: 50px;
  line-height: 40px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  padding-inline: 0px !important;
}
.cloudmodel .ant-affix .ant-anchor-link a::before {
  content: '';
  display: none;
}
.cloudmodel .ant-affix .ant-anchor-link:nth-of-type(1) {
  border-left: 1px solid #ddd;
}
.cloudRecord {
  display: flex;
  width: 1200px;
  margin: 0px auto;
  height: 390px;
  align-items: center;
}
.cloudRecord .text {
  font-size: 14px;
  color: #555;
  line-height: 30px;
}
.cloudRecord h3 {
  margin: 0px;
  margin-top: 30px;
  line-height: 50px;
  font-size: 30px;
}
.cloudRecord ul {
  display: flex;
  padding-top: 15px;
}
.cloudRecord ul li {
  font-size: 14px;
  flex: 1;
}
.cloudRecord ul .list {
  padding: 0px 25px;
}
.cloudRecord ul h3 {
  margin: 0px;
  line-height: 50px;
  padding-top: 10px;
  font-size: 16px;
}
.cloudRecord ul div {
  font-size: 12px;
  color: #555;
}
.zhusnshu {
  display: flex;
  width: 1200px;
  margin: 0px auto;
  height: 360px;
  align-items: center;
}
.zhusnshu .text {
  font-size: 14px;
  color: #555;
  line-height: 30px;
}
.zhusnshu h3 {
  margin: 0px;
  margin-top: 10px;
  line-height: 50px;
  font-size: 30px;
}
.zhusnshu ul {
  display: flex;
  padding-top: 15px;
}
.zhusnshu ul li {
  font-size: 14px;
  flex: 1;
}
.zhusnshu ul .list {
  padding: 0px 25px;
}
.zhusnshu ul h3 {
  margin: 0px;
  line-height: 50px;
  padding-top: 10px;
  font-size: 16px;
}
.zhusnshu ul div {
  font-size: 12px;
  color: #555;
}
.zixunBox {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
}
.zixunBox li {
  width: 33.3%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-bottom: 20px;
}
.zixunBox li h3 {
  font-size: 14px;
  margin: 0px;
  line-height: 30px;
}
.zixunBox li p {
  margin: 0px;
  font-size: 12px;
  color: #555;
}
.zixunBox li:first-child,
.zixunBox li:nth-of-type(4) {
  padding: 0px;
}
.cloudBanner {
  height: 430px;
  min-width: 1200px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat top center;
}
.yongyou {
  padding-bottom: 50px;
}
.yongyou .ant-tabs-nav {
  margin-bottom: 0px !important;
}
.yongyou .ant-tabs-nav-list {
  width: 100%;
  justify-content: center;
}
.yongyou .ant-tabs-nav-list .ant-tabs-ink-bar {
  display: none;
}
.yongyou-con {
  height: 450px;
  width: 100%;
}
.yongyou-list {
  padding-top: 50px;
}
.yongyou-text {
  height: 400px;
  width: 100%;
}
.yongyou-link {
  width: 1400px;
  margin: 0px auto;
  position: relative;
  height: 400px;
}
.yongyou-link a {
  display: block;
  background: #fff;
  height: 40px;
  width: 120px;
  position: absolute;
  left: 0px;
  bottom: 30px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  border-radius: 5px;
}
.yongyou .slick-dots {
  background: #f5f5f5;
  top: 0px;
  height: 50px;
}
.yongyou .slick-dots li {
  height: 50px;
  width: 120px;
}
.yongyou .slick-dots li button {
  height: 50px;
  opacity: 1;
  background-color: unset;
}
.yongyou .slick-dots li button::after {
  inset: 0px;
  height: 50px;
  line-height: 50px;
  color: #333;
  display: block;
  font-size: 14px;
}
.yongyou .slick-dots li::after {
  display: none;
}
.yongyou .slick-dots li:nth-of-type(1) button::after {
  content: '财务云';
}
.yongyou .slick-dots li:nth-of-type(2) button::after {
  content: '人力云';
}
.yongyou .slick-dots li:nth-of-type(3) button::after {
  content: '供应链云';
}
.yongyou .slick-dots li:nth-of-type(4) button::after {
  content: '营销云';
}
.yongyou .slick-dots li:nth-of-type(5) button::after {
  content: '采购云';
}
.yongyou .slick-dots li:nth-of-type(6) button::after {
  content: '制造云';
}
.yongyou .slick-dots li:nth-of-type(7) button::after {
  content: '研发云';
}
.yongyou .slick-dots li:nth-of-type(8) button::after {
  content: '项目云';
}
.yongyou .slick-dots li:nth-of-type(9) button::after {
  content: '资产云';
}
.yongyou .slick-dots li:nth-of-type(10) button::after {
  content: '协同云';
}
.yongyou .slick-dots .slick-active {
  background: #c00;
  color: #fff;
  width: 120px !important;
}
.yongyou .slick-dots .slick-active button::after {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Cloud/index.less"],"names":[],"mappings":"AAAA;EAAY,oBAAA;AAEZ;AAFA;EACe,aAAA;EAAe,aAAA;EAAc,gBAAA;AAM5C;AAPA;EAGM,OAAA;EAAQ,sBAAA;EAAuB,gBAAA;EAAiB,aAAA;EAAc,gBAAA;EAC9D,kBAAA;EAAoB,eAAA;EAAiB,8BAAA;AAa3C;AAjBA;EAMsB,kBAAA;EAAwB,gCAAA;EAAkC,iBAAA;AAgBhF;AAtBA;EAOmC,2BAAA;AAkBnC;AAzBA;EAQ8B,6BAAA;AAoB9B;AA5BA;EAS8B,WAAA;EAAY,cAAA;EAAgB,aAAA;AAwB1D;AAjCA;EAUS,iBAAA;EAAkB,cAAA;AA2B3B;AArCA;;EAWwF,yEAAA;AA8BxF;AAzCA;;EAYwF,yEAAA;AAiCxF;AA7CA;;EAawF,yEAAA;AAoCxF;AAjDA;EAgBS,OAAA;EAAQ,sBAAA;EAAuB,gBAAA;EAAiB,YAAA;EAAa,iBAAA;EAAkB,gBAAA;EAC/E,kBAAA;EAAoB,eAAA;EAAiB,8BAAA;AA2C9C;AA5DA;EAmBiC,WAAA;EAAY,aAAA;AA6C7C;AAhEA;EAoBsC,2BAAA;AA+CtC;AA5CA;EAAa,aAAA;EAAe,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAe,mBAAA;AAmD1E;AAnDA;EACS,eAAA;EAAgB,WAAA;EAAY,iBAAA;AAuDrC;AAxDA;EAEO,WAAA;EAAY,gBAAA;EAAiB,iBAAA;EAAkB,eAAA;AA4DtD;AA9DA;EAGM,aAAA;EAAe,iBAAA;AA+DrB;AAlEA;EAIS,eAAA;EAAiB,OAAA;AAkE1B;AAtEA;EAKY,iBAAA;AAoEZ;AAzEA;EAMS,WAAA;EAAa,iBAAA;EAAkB,iBAAA;EAAmB,eAAA;AAyE3D;AA/EA;EAOU,eAAA;EAAgB,WAAA;AA4E1B;AAzEA;EACG,aAAA;EAAe,aAAA;EAAc,gBAAA;EAAiB,aAAA;EAAc,mBAAA;AA+E/D;AAhFA;EAES,eAAA;EAAgB,WAAA;EAAY,iBAAA;AAmFrC;AArFA;EAGO,WAAA;EAAY,gBAAA;EAAiB,iBAAA;EAAkB,eAAA;AAwFtD;AA3FA;EAIM,aAAA;EAAe,iBAAA;AA2FrB;AA/FA;EAKS,eAAA;EAAiB,OAAA;AA8F1B;AAnGA;EAMY,iBAAA;AAgGZ;AAtGA;EAOS,WAAA;EAAa,iBAAA;EAAkB,iBAAA;EAAmB,eAAA;AAqG3D;AA5GA;EAQU,eAAA;EAAgB,WAAA;AAwG1B;AArGA;EAAW,aAAA;EAAe,eAAA;EAAiB,iBAAA;AA0G3C;AA1GA;EACM,YAAA;EAAa,sBAAA;EAAwB,kBAAA;EAAmB,oBAAA;AA+G9D;AAhHA;EAES,eAAA;EAAgB,WAAA;EAAY,iBAAA;AAmHrC;AArHA;EAGQ,WAAA;EAAY,eAAA;EAAiB,WAAA;AAuHrC;AA1HA;;EAKsC,YAAA;AAyHtC;AArHA;EACG,aAAA;EAAc,iBAAA;EAAkB,WAAA;EAAY,wEAAA;AA0H/C;AAxHA;EAAU,oBAAA;AA2HV;AA3HA;EACiB,6BAAA;AA6HjB;AA9HA;EAEsB,WAAA;EAAa,uBAAA;AAgInC;AAlIA;EAGwB,aAAA;AAkIxB;AAhIG;EAAM,aAAA;EAAc,WAAA;AAoIvB;AAnIG;EAAO,iBAAA;AAsIV;AArIG;EAAO,aAAA;EAAc,WAAA;AAyIxB;AAxIG;EAAQ,aAAA;EAAc,gBAAA;EAAiB,kBAAA;EAAmB,aAAA;AA8I7D;AA9IG;EAEM,cAAA;EAAgB,gBAAA;EAAiB,YAAA;EAAa,YAAA;EAAa,kBAAA;EAAoB,SAAA;EAAU,YAAA;EACzF,iBAAA;EAAkB,kBAAA;EAAoB,eAAA;EAAgB,kBAAA;AAwJ/D;AAnKA;EAee,mBAAA;EAAoB,QAAA;EAAU,YAAA;AAyJ7C;AAxKA;EAgBS,YAAA;EAAa,YAAA;AA4JtB;AA5KA;EAiBgB,YAAA;EAAa,UAAA;EAAW,uBAAA;AAgKxC;AAjLA;EAkBuB,UAAA;EAAY,YAAA;EAAa,iBAAA;EAAkB,WAAA;EAAY,cAAA;EAAgB,eAAA;AAuK9F;AAzLA;EAoBgB,aAAA;AAwKhB;AA5LA;EAqBsC,cAAA;AA0KtC;AA/LA;EAsBsC,cAAA;AA4KtC;AAlMA;EAuBsC,eAAA;AA8KtC;AArMA;EAwBsC,cAAA;AAgLtC;AAxMA;EAyBsC,cAAA;AAkLtC;AA3MA;EA0BsC,cAAA;AAoLtC;AA9MA;EA2BsC,cAAA;AAsLtC;AAjNA;EA4BsC,cAAA;AAwLtC;AApNA;EA6BsC,cAAA;AA0LtC;AAvNA;EA8BuC,cAAA;AA4LvC;AA1NA;EA+BoB,gBAAA;EAAiB,WAAA;EAAY,uBAAA;AAgMjD;AA/NA;EAgCuB,WAAA;AAkMvB","sourcesContent":[".cloudmodel{padding-bottom:50px;\n   .ant-anchor{display: flex; width:1200px; margin:0px auto;}\n   .ant-anchor-link{\n      flex:1; border:1px solid #ddd; border-left:0px; height:200px; background:#fff; \n      text-align: center; cursor: pointer; padding-inline:0px !important;\n   }\n   .ant-anchor-link a{text-align: center;     white-space: pre-wrap !important; padding:0px 15px;}\n   .ant-anchor-link:nth-of-type(1){border-left:1px solid #ddd;}\n   .ant-anchor-wrapper:before{border-bottom: 0px !important;}\n   .ant-anchor-link a::before{content:''; display: block; height: 140px;}\n   .text{line-height:30px; display: block;}\n   .ant-anchor-link:nth-of-type(1) a::before, .ant-anchor-link:nth-of-type(4) a::before{background: url(../../static/images/a1.png) no-repeat center 40px; }\n   .ant-anchor-link:nth-of-type(2) a::before, .ant-anchor-link:nth-of-type(5) a::before{background: url(../../static/images/a2.png) no-repeat center 40px; }\n   .ant-anchor-link:nth-of-type(3) a::before, .ant-anchor-link:nth-of-type(6) a::before{background: url(../../static/images/a3.png) no-repeat center 40px; }\n   .ant-affix{\n      .ant-anchor-link{\n         flex:1; border:1px solid #ddd; border-left:0px; height:50px; line-height:40px; background:#fff; \n         text-align: center; cursor: pointer; padding-inline:0px !important;\n      }\n      .ant-anchor-link a::before{content:''; display: none;}\n      .ant-anchor-link:nth-of-type(1){border-left:1px solid #ddd;}\n   }\n}\n.cloudRecord{display: flex; width:1200px; margin:0px auto; height: 390px; align-items: center;\n   .text{font-size:14px; color:#555; line-height: 30px;}\n   h3{ margin:0px; margin-top:30px; line-height:50px; font-size:30px;}\n   ul{display: flex; padding-top:15px;\n      li{font-size: 14px; flex:1; }\n      .list{padding:0px 25px;}\n      h3{margin: 0px; line-height:50px; padding-top: 10px; font-size:16px;}\n      div{font-size:12px; color:#555;}\n   }\n}\n.zhusnshu{\n   display: flex; width:1200px; margin:0px auto; height:360px; align-items: center;\n   .text{font-size:14px; color:#555; line-height: 30px;}\n   h3{ margin:0px; margin-top:10px; line-height:50px; font-size:30px;}\n   ul{display: flex; padding-top:15px;\n      li{font-size: 14px; flex:1; }\n      .list{padding:0px 25px;}\n      h3{margin: 0px; line-height:50px; padding-top: 10px; font-size:16px;}\n      div{font-size:12px; color:#555;}\n   }\n}\n.zixunBox{ display: flex; flex-wrap: wrap; padding-top:20px;\n   li{width:33.3%; box-sizing: border-box; padding-left:20px; padding-bottom:20px;\n      h3{font-size:14px; margin:0px; line-height:30px;}\n      p{margin:0px; font-size: 12px; color:#555;}\n   }\n   li:first-child, li:nth-of-type(4) {padding:0px;}\n   \n\n}\n.cloudBanner{\n   height:430px; min-width:1200px; width:100%; background:url(../../static/images/cloud-banner.jpg) no-repeat top center;\n}\n.yongyou{ padding-bottom:50px;\n   .ant-tabs-nav{margin-bottom: 0px !important;}\n   .ant-tabs-nav-list{width: 100%; justify-content: center;\n      .ant-tabs-ink-bar{display: none;}\n   }\n   &-con{height:450px; width:100%;}\n   &-list{padding-top:50px;}\n   &-text{height:400px; width:100%;}\n   &-link{ width:1400px; margin:0px auto; position:relative; height:400px;\n      a{\n         display: block; background:#fff; height:40px; width:120px; position: absolute; left:0px; bottom:30px;\n         line-height:40px; text-align: center; font-size:14px; border-radius: 5px;\n      }\n   }\n\n   .slick-dots{background:#f5f5f5; top: 0px; height: 50px;\n      li{height:50px; width:120px;\n         button{height:50px; opacity:1; background-color:unset;}\n         button::after{inset: 0px; height:50px; line-height:50px; color:#333; display: block; font-size:14px;}\n      }\n      li::after{display: none;}\n      li:nth-of-type(1) button::after{content:'财务云'; }\n      li:nth-of-type(2) button::after{content:'人力云'; }\n      li:nth-of-type(3) button::after{content:'供应链云'; }\n      li:nth-of-type(4) button::after{content:'营销云'; }\n      li:nth-of-type(5) button::after{content:'采购云'; }\n      li:nth-of-type(6) button::after{content:'制造云'; }\n      li:nth-of-type(7) button::after{content:'研发云'; }\n      li:nth-of-type(8) button::after{content:'项目云'; }\n      li:nth-of-type(9) button::after{content:'资产云'; }\n      li:nth-of-type(10) button::after{content:'协同云'; }\n      .slick-active{background:#c00; color:#fff; width:120px !important;\n         button::after{color:#fff;}\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
